import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Button } from './ui/button';

// Shared list — keep this in sync with /app/frontend/src/pages/FAQPage.jsx
const FAQS = [
  {
    question: 'What is a Google Review Standee?',
    answer:
      'A Google Review Standee is a smart NFC + QR-enabled display that allows customers to instantly leave a Google review by simply tapping their phone or scanning the QR code.',
  },
  {
    question: 'What is a TripAdvisor Review Standee?',
    answer:
      'A TripAdvisor Review Standee helps hotels, restaurants, tours, and tourism businesses collect more TripAdvisor reviews quickly and effortlessly using NFC tap and QR scan technology.',
  },
  {
    question: 'How does the standee work?',
    answer:
      'Customers simply tap their phone on the standee (NFC) or scan the QR code. They are instantly redirected to your Google or TripAdvisor review page.',
  },
  {
    question: 'Do customers need to download an app?',
    answer:
      'No. Our review standees work directly through the customer\u2019s smartphone browser \u2014 no app required.',
  },
  {
    question: 'Does it work on both iPhone and Android?',
    answer:
      'Yes. The standees are compatible with most modern iPhone and Android devices.',
  },
  {
    question: 'Where should I place the standee?',
    answer:
      'Best placement areas include reception desks, cash counters, restaurant tables, hotel check-in areas, and waiting lounges.',
  },
];

const SUPPORT_EMAIL = 'orders.smartconnections@gmail.com';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-navy mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Quick answers to the most common questions about Smart Connections.
          </p>
        </div>

        <div className="grid lg:grid-cols-[2fr,1fr] gap-12">
          {/* Left - FAQ List */}
          <div>
            <div className="space-y-4">
              {FAQS.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={index}
                    data-testid={`home-faq-item-${index}`}
                    className="border-b border-gray-200 pb-4"
                  >
                    <button
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      data-testid={`home-faq-toggle-${index}`}
                      className="w-full flex items-center justify-between text-left py-4"
                    >
                      <span className="text-base sm:text-lg font-semibold text-navy pr-4">
                        {faq.question}
                      </span>
                      {isOpen ? (
                        <Minus className="w-5 h-5 text-navy flex-shrink-0" />
                      ) : (
                        <Plus className="w-5 h-5 text-navy flex-shrink-0" />
                      )}
                    </button>
                    {isOpen && (
                      <p className="text-gray-600 pb-4 leading-relaxed">
                        {faq.answer}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="mt-8">
              <a
                href="/faq"
                data-testid="home-faq-see-all-link"
                className="inline-block text-sm font-semibold text-coral hover:underline"
              >
                See all FAQs →
              </a>
            </div>
          </div>

          {/* Right - Contact Card */}
          <div className="bg-white rounded-[2rem] p-8 shadow-sm">
            <div className="bg-navy rounded-2xl w-16 h-16 flex items-center justify-center mb-6">
              <span className="text-white text-2xl">📧</span>
            </div>
            <h3 className="text-2xl font-bold text-navy mb-4">
              Do you have more<br />questions?
            </h3>
            <p className="text-sm text-gray-600 mb-6">
              Drop us a line and our team will get back to you within a few hours.
            </p>
            <Button
              data-testid="home-faq-direct-mail-btn"
              onClick={() => {
                window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
                  'Smart Connections enquiry'
                )}`;
              }}
              className="bg-red-400 hover:bg-red-500 text-white rounded-full px-8 py-6 w-full"
            >
              Shoot a Direct Mail
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
